export const testIds = {
  auth: {
    logoutButton: 'utcLogoutButton',
    loadingAuth: 'loading-auth',
    errorMessage: 'error-message',
  },
} as const;

export const automationIds = {
  noSalesCompanyCode: 'no_sales_company_code',
  errorMessage: 'error_message',
  warningText: 'warning_text',
  loginInfo: 'login_info',
  welcomeHeader: 'welcome_header',
  signinBtn: 'signin_btn',
  copyrightInfo: 'copyright_info',
  husqvarnaLogo: 'husqvarna_logo',

  Login: {
    genericErrorWrapper: 'login_generic_error_wrapper',
    genericError: 'login_generic_error',

    noDealerErrorWrapper: 'login_no_dealer_error_wrapper',
    noDealerError: 'login_no_dealer_error',

    apiErrorWrapper: 'login_api_error_wrapper',
    apiError: 'login_api_error',
  }
} as const;
